// import React from "react";
// import Lottie from "react-lottie";
// import "./Gold_Coin_Lottie.css";
// import * as animationData from "./Gold_Coin_Lottie.json";

// function Gold_Coin_Lottie() {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <section className="main">
//       <div className="Gold_Coin_Lottie_icon">
//         <Lottie className="me-auto" options={defaultOptions} />
//       </div>
//     </section>
//   );
// }
// export default Gold_Coin_Lottie;

import React from "react";
import Lottie from "lottie-react";
import animationData from "./Gold_Coin_Lottie.json";
import "./Gold_Coin_Lottie.css";

function Gold_Coin_Lottie() {
  if (!animationData) return null;

  return (
    <section className="main">
      <div className="Gold_Coin_Lottie_icon">
        <Lottie
          animationData={animationData}
          loop={true}
          autoplay={true}
          className="me-auto"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </section>
  );
}

export default Gold_Coin_Lottie;
